<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Rubro
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Maestros</span>
      <span> /</span>
      <span>Rubro</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<form [formGroup]='formHeader' novalidate (ngSubmit)="loadData()">
  <div class="card mb-2 wow">
    <!--Card content-->
    <div class="card-body justify-content-between">
      <div class="row filtros-header" style="border-bottom: 1px solid #dee2e6">
        <div></div>
        <button type="button" mdbBtn color="info" size="sm" mdbWavesEffect (click)="openModalRubro()">
          Agregar
        </button>
      </div>
      <div class="row filtros-body">
        <div class="col" style="max-width: 300px">
          <div class="md-form">
            <div class="md-form">
              <input value="" type="text" id="desc" class="form-control" placeholder="Descripción" required #desc
                formControlName="descripcion" />
              <label for="desc">Descripción</label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6">
      <div></div>
      <button mdbBtn color="secondary" size="sm" mdbWavesEffect type="submit">
        <mdb-icon fas icon="search"></mdb-icon>
        Buscar
      </button>
    </div>
  </div>
</form>
<!-- Cabecera de botones -->
<div class="card mb-2 wow">
  <!--Card content-->
  <div class="card-body">
    <div class="table-responsive">
      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">Codigo</th>
            <th scope="col">Descripción</th>
            <th scope="col">Estado</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let rubro of listaRubros">
            <td>{{rubro.codigo}}</td>
            <td>{{rubro.descripcion}}</td>
            <td>
              <mdb-badge pill="true" success="true" *ngIf="rubro.activo">Activo</mdb-badge>
              <mdb-badge pill="true" warning="true" *ngIf="!rubro.activo">Inactivo</mdb-badge>
            </td>
            <td><button mdbBtn type="button" size="sm" color="info" mdbWavesEffect class="btn-actions-sm"
                mdbTooltip="Editar" placement="right" (click)="editar(rubro)">
                <mdb-icon fas icon="pen"></mdb-icon>
              </button>
              <button class="btn-actions-sm" color="primary" mdbBtn type="button" mdbWavesEffect *ngIf="!rubro.activo"
                mdbTooltip="Activar" placement="right" (click)="desactivar(rubro)">
                <mdb-icon fas icon="ban"></mdb-icon>
              </button>
              <span class="btn-actions-sm" *ngIf="!rubro.activo">&nbsp;</span>
              <button class="btn-actions-sm" color="success" mdbBtn type="button" mdbWavesEffect *ngIf="rubro.activo"
                mdbTooltip="Desactivar" placement="right" (click)="activar(rubro)">
                <mdb-icon fas icon="check"></mdb-icon>
              </button>
            </td>
          </tr>
        </tbody>
        <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
          *ngIf="listaRubros?.length > 0"></app-pagination>
      </table>
    </div>
  </div>
</div>

<!-- MODAL Agregar e Editar Rubro -->
<app-rubro-modal-add-edit (onAddEdit)="onAddEdit($event)"></app-rubro-modal-add-edit>